/**
 * Классы сетки вкладки. Одна сетка и для просмотра, и для правки: иначе админ двигал бы
 * элементы на одной вёрстке, а клиент видел бы другую.
 *
 * Ниже `xl` (1280 px) явных позиций нет: элементы идут одной колонкой в порядке чтения — он же
 * порядок в DOM. Поэтому телефон и узкий экран выглядят как до сетки.
 */
export const GRID_CLASS =
  'grid grid-cols-1 gap-6 xl:gap-x-4 xl:gap-y-6 '
  + 'xl:[grid-template-columns:repeat(var(--grid-cols),minmax(0,1fr))] '
  + 'xl:[grid-auto-rows:minmax(16px,auto)]';

/**
 * Ячейка тянет содержимое на всю свою высоту (`grow` у детей): соседи по ряду выравниваются по
 * самому высокому, как раньше в сетках с `items-stretch`. Ни `transform`, ни `z-index` у ячейки
 * в просмотре нет: выпадающие списки шапок не должны уходить под соседей.
 */
export const GRID_CELL_CLASS =
  'flex min-w-0 flex-col [&>*]:min-w-0 [&>*]:grow '
  + 'xl:[grid-column:var(--grid-column)] xl:[grid-row:var(--grid-row)]';

/** Место элемента в CSS Grid: линии считаются с единицы, высота `h` — минимум, а не потолок. */
export const cellStyle = (item) => ({
  '--grid-column': `${item.x + 1} / span ${item.w}`,
  '--grid-row': `${item.y + 1} / span ${item.h}`
});
